import React from "react"
import { StepByStepContainer, Step, Body, Number } from "./style"

const StepByStep = ({ data }) => {
  console.log('data:', data)
  return (
    <StepByStepContainer>
      <ol>
        {data.map((step, index) => {
          return (
            <Step key={index}>
              <Number small={index === 0 || index === 1}>{index + 1}</Number>
              <h4>{step.title}</h4>
              <Body dangerouslySetInnerHTML={{ __html: step.description }} />
            </Step>
          )
        })}
      </ol>
    </StepByStepContainer>
  )
}

export default StepByStep
